import React from 'react'
import { UncontrolledCollapse, CardBody, Card } from 'reactstrap'
import { HubspotBrochureDownload } from '.'
import Lazyload from 'react-lazy-load'
import { Trans, useTranslation } from 'gatsby-plugin-react-i18next'
import VideoCarousel from './VideoCarousel'

const Partnership = () => {
  const { t } = useTranslation()
  const wistiaVideoUrls = [
    'https://www.youtube.com/embed/4h9eRm4hNe0',
    'https://www.youtube.com/embed/LSX4pxSB6Qw',
    'https://www.youtube.com/embed/L_39IykL-O4',
  ]
  return (
    <>
      <div className="prime-vf-page partnership-page">
        <section
          className="bg-dark hero-bg position-relative partner-hero-wrapper1 partnerhip-page about-pattern-vfit bg-glow"
          style={{ flexDirection: 'column', background: 'linear-gradient(181.22deg, #303740 0%, #1d2228 100%)' }}
        >
          <div className="container custom_container d-flex justify-content-center align-items-center p0 m-d-block text-center">
            <div className="col-12 partner-hero-title">
              <div className="">
                <h1 className="font-weight-semibold hero-heading no-br text-center">
                  <Trans>
                    <span style={{ fontSize: '34px' }}>Empower Your Business &</span>
                    <br />
                    Unlock New Revenue with Vantage Fit
                  </Trans>
                </h1>
                <p className="text-center mb-5 text-white">
                  <Trans>
                    Monetize the demand for corporate wellness! Partner with Vantage Fit and offer organizations a
                    digital gamified solution <br /> that transforms employee well-being.
                  </Trans>
                </p>
                <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                  <a href="#form-partner" className="vfitcompanycta arrowbtn-img">
                    <Trans>Become a Partner</Trans>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="section-padding about-pattern-vfit sec-2"
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <div className="container custom_container d-flex justify-content-center align-items-center px-6 mt-0 m-d-block ">
            <div
              className="col-12 p-0 row"
              style={{ background: 'linear-gradient(181.22deg, #1d2228 0%, #303740 100%)', borderRadius: '20px' }}
            >
              <div className="col-12 col-md-6">
                <div className="row px-5">
                  <h2 className="text-white text-center text-md-left mt-0 mb-0 pt-0">
                    <Trans>
                      Grow your business <br /> as a Vantage Fit Partner
                    </Trans>
                  </h2>
                  <ul className="pricing-one-time-bullets pricing-standard-bullets mt-0">
                    <li className="text-white mb-4">
                      <span style={{ fontSize: '22px', fontWeight: '500', lineHeight: '100%' }} className="mb-1">
                        <Trans>Unlock New Revenue Streams</Trans>
                      </span>
                      <br />
                      <p className="mt-2">
                        <Trans>Earn high-margin commissions by reselling a premium corporate wellness solution.</Trans>
                      </p>
                    </li>
                    <li className="text-white mb-4">
                      <span style={{ fontSize: '22px', fontWeight: '500', lineHeight: '100%' }} className="mb-1">
                        <Trans>Attract & Retain More Clients</Trans>
                      </span>
                      <p className="mt-2">
                        <Trans>
                          Offer an AI-powered, digital gamified wellness platform that sets you apart from competitors.
                        </Trans>
                      </p>
                    </li>
                    <li className="text-white mb-4">
                      <span style={{ fontSize: '22px', fontWeight: '500', lineHeight: '100%' }} className="mb-1">
                        <Trans>Enhance Client Value</Trans>
                      </span>
                      <p className="mt-2">
                        <Trans>
                          Help organizations boost employee engagement and productivity through wellness programs.
                        </Trans>
                      </p>
                    </li>
                    <li className="text-white mb-4">
                      <span style={{ fontSize: '22px', fontWeight: '500', lineHeight: '100%' }} className="mb-1">
                        <Trans>Seamless Integration</Trans>
                      </span>
                      <p className="mt-2">
                        <Trans>
                          Easily connect with existing HR, rewards, and workforce management systems for a smooth
                          rollout.
                        </Trans>
                      </p>
                    </li>
                    <li className="text-white">
                      <span style={{ fontSize: '22px', fontWeight: '500', lineHeight: '100%' }} className="mb-1">
                        <Trans>Comprehensive Partner Support</Trans>
                      </span>
                      <p className="mt-2">
                        <Trans>Gain access to marketing resources and dedicated assistance to ensure success.</Trans>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-12 col-md-6 pt-5 px-0 pt-md-0">
                <div className="w-100 h-100  partner-right-image"></div>
              </div>
            </div>
          </div>
          <div className="container custom_container d-flex justify-content-center align-items-center mt-5  m-d-block">
            <div className="row">
              <h2 className="font-weight-semibold text-white text-center w-100">
                <Trans>Why Clients Love Vantage Fit?</Trans>
              </h2>
              <div className="row justify-content-center mt-5 " style={{ columnGap: '20px', rowGap: '20px' }}>
                <div
                  className="col-3 p-3 svg-container "
                  style={{ borderTopRightRadius: '20px', borderBottomLeftRadius: '20px' }}
                >
                  <svg
                    className="mb-3"
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="51"
                    viewBox="0 0 50 51"
                    fill="none"
                  >
                    <path
                      d="M8.73198 27.1719L10.1592 25.8126C11.0307 24.9827 12.1424 24.4497 13.3351 24.2899C14.729 24.1033 16.1427 24.4382 17.3046 25.2304L17.8111 25.5757C19.8063 26.9361 21 29.1948 21 31.6096V31.9854C21 32.7264 20.8586 33.4606 20.5834 34.1487C19.9015 35.8534 18.4558 37.1369 16.6822 37.6119L13.8554 38.3691C12.3481 38.7728 10.742 38.557 9.39475 37.7697C7.34226 36.5702 6.22097 34.2468 6.55886 31.8937L6.66005 31.1889C6.88026 29.6553 7.61005 28.2404 8.73198 27.1719Z"
                      fill="white"
                    />
                    <path
                      d="M32.6669 27.0183L34.1045 25.7404C35.0134 24.9325 36.146 24.4193 37.3527 24.2684C38.7406 24.0949 40.1456 24.4109 41.3257 25.1618L41.9297 25.5462C43.842 26.7631 45 28.8726 45 31.1392V31.3855C45 32.1208 44.8506 32.8485 44.561 33.5244C43.8925 35.0841 42.5333 36.2417 40.8871 36.6532L37.672 37.457C36.2753 37.8062 34.7984 37.6173 33.5345 36.9279C31.4134 35.7709 30.2448 33.4087 30.6122 31.0207L30.6609 30.7043C30.8801 29.2796 31.5895 27.976 32.6669 27.0183Z"
                      fill="white"
                    />
                    <path
                      d="M17.9 31.4H15.7C15.4085 31.3991 15.1292 31.283 14.9231 31.0769C14.717 30.8708 14.6009 30.5915 14.6 30.3V28.1C14.6 27.8083 14.4841 27.5285 14.2778 27.3222C14.0715 27.1159 13.7917 27 13.5 27C13.2083 27 12.9285 27.1159 12.7222 27.3222C12.5159 27.5285 12.4 27.8083 12.4 28.1V30.3C12.3991 30.5915 12.283 30.8708 12.0769 31.0769C11.8708 31.283 11.5915 31.3991 11.3 31.4H9.1C8.80826 31.4 8.52847 31.5159 8.32218 31.7222C8.11589 31.9285 8 32.2083 8 32.5C8 32.7917 8.11589 33.0715 8.32218 33.2778C8.52847 33.4841 8.80826 33.6 9.1 33.6H11.3C11.4446 33.5995 11.5879 33.6276 11.7215 33.6827C11.8552 33.7378 11.9767 33.8188 12.0789 33.9211C12.1812 34.0233 12.2622 34.1448 12.3173 34.2785C12.3724 34.4121 12.4005 34.5554 12.4 34.7V36.9C12.4 37.1917 12.5159 37.4715 12.7222 37.6778C12.9285 37.8841 13.2083 38 13.5 38C13.7917 38 14.0715 37.8841 14.2778 37.6778C14.4841 37.4715 14.6 37.1917 14.6 36.9V34.7C14.5995 34.5554 14.6276 34.4121 14.6827 34.2785C14.7378 34.1448 14.8188 34.0233 14.9211 33.9211C15.0233 33.8188 15.1448 33.7378 15.2785 33.6827C15.4121 33.6276 15.5554 33.5995 15.7 33.6H17.9C18.1917 33.6 18.4715 33.4841 18.6778 33.2778C18.8841 33.0715 19 32.7917 19 32.5C19 32.2083 18.8841 31.9285 18.6778 31.7222C18.4715 31.5159 18.1917 31.4 17.9 31.4Z"
                      fill="#41D8B4"
                    />
                    <path
                      d="M36 36C38.2091 36 40 34.2091 40 32C40 29.7909 38.2091 28 36 28C33.7909 28 32 29.7909 32 32C32 34.2091 33.7909 36 36 36Z"
                      fill="#41D8B4"
                    />
                    <path
                      d="M49.6304 42.9883L47.0982 29.9847C46.6752 27.5319 45.4631 25.2842 43.6461 23.5831C41.8291 21.8819 39.5066 20.8203 37.0312 20.5596C37.0609 20.9286 37.0103 21.2997 36.8828 21.6473C36.7553 21.9948 36.554 22.3107 36.2927 22.573L33.8837 24.982C33.4348 25.4306 32.8393 25.7024 32.2063 25.7476C31.5733 25.7928 30.9452 25.6084 30.4371 25.2282L30.2701 25.1051C30.0063 25.2194 29.7426 25.3337 29.47 25.4304L29.4436 25.6414C29.3512 26.2691 29.037 26.843 28.558 27.2591C28.079 27.6752 27.4669 27.9061 26.8324 27.9098H23.4386C22.8041 27.9061 22.1919 27.6752 21.7129 27.2591C21.2339 26.843 20.9198 26.2691 20.8273 25.6414L20.801 25.4304C20.5284 25.3337 20.2647 25.2194 20.0009 25.1051C19.4942 25.5383 18.8445 25.7675 18.1781 25.748C17.5118 25.7285 16.8766 25.4617 16.3961 24.9996L13.9959 22.5906C13.7303 22.3266 13.5246 22.0086 13.3926 21.6582C13.2607 21.3078 13.2055 20.9331 13.2309 20.5596C10.7566 20.8205 8.43515 21.8824 6.61961 23.5836C4.80407 25.2849 3.59377 27.5325 3.17275 29.9847L0.640619 42.9883C0.453818 43.9335 0.479997 44.9084 0.717252 45.8422C0.954506 46.776 1.39687 47.6453 2.01219 48.3867C4.94876 52.1936 11.4813 51.2001 13.1166 46.6634L13.6881 45.2303C14.0844 44.2348 14.7708 43.3815 15.6582 42.781C16.5456 42.1805 17.593 41.8606 18.6645 41.8629H31.6065C32.6771 41.8596 33.7238 42.1791 34.61 42.7799C35.4962 43.3806 36.1807 44.2346 36.574 45.2303L37.1543 46.6634C38.7897 51.2001 45.3134 52.1936 48.2588 48.3867C48.8741 47.6453 49.3165 46.776 49.5537 45.8422C49.791 44.9084 49.8172 43.9335 49.6304 42.9883ZM17.2226 34.7589H16.3434V35.6381C16.3434 36.3376 16.0655 37.0085 15.5708 37.5032C15.0762 37.9978 14.4053 38.2757 13.7057 38.2757C13.0062 38.2757 12.3353 37.9978 11.8406 37.5032C11.346 37.0085 11.0681 36.3376 11.0681 35.6381V34.7589H10.1889C9.48933 34.7589 8.81843 34.481 8.32378 33.9863C7.82913 33.4917 7.55123 32.8208 7.55123 32.1212C7.55123 31.4217 7.82913 30.7508 8.32378 30.2561C8.81843 29.7615 9.48933 29.4836 10.1889 29.4836H11.0681V28.6044C11.0681 27.9048 11.346 27.2339 11.8406 26.7393C12.3353 26.2446 13.0062 25.9667 13.7057 25.9667C14.4053 25.9667 15.0762 26.2446 15.5708 26.7393C16.0655 27.2339 16.3434 27.9048 16.3434 28.6044V29.4836H17.2226C17.9221 29.4836 18.593 29.7615 19.0877 30.2561C19.5823 30.7508 19.8602 31.4217 19.8602 32.1212C19.8602 32.8208 19.5823 33.4917 19.0877 33.9863C18.593 34.481 17.9221 34.7589 17.2226 34.7589ZM36.5653 37.3965C35.5219 37.3965 34.502 37.0871 33.6345 36.5075C32.767 35.9278 32.0908 35.1039 31.6915 34.14C31.2923 33.1761 31.1878 32.1154 31.3913 31.0921C31.5949 30.0688 32.0973 29.1288 32.8351 28.3911C33.5728 27.6533 34.5128 27.1509 35.5361 26.9473C36.5594 26.7438 37.6201 26.8482 38.584 27.2475C39.5479 27.6468 40.3718 28.3229 40.9515 29.1904C41.5311 30.058 41.8405 31.0779 41.8405 32.1212C41.8394 33.52 41.2833 34.8611 40.2942 35.8502C39.3051 36.8393 37.964 37.3954 36.5653 37.3965Z"
                      fill="white"
                    />
                    <path
                      d="M13.5823 15.4097L14.8835 15.5943C15.1205 16.49 15.4753 17.3504 15.9386 18.1528L15.1561 19.1991C15.0289 19.3686 14.9669 19.5782 14.9814 19.7897C14.996 20.0011 15.086 20.2003 15.2352 20.3508L17.6267 22.7423C17.7772 22.8915 17.9764 22.9815 18.1878 22.996C18.3993 23.0106 18.6089 22.9486 18.7784 22.8214L19.8247 22.0389C20.6271 22.5023 21.4875 22.8571 22.3832 23.094L22.5678 24.3952C22.5991 24.6043 22.7039 24.7953 22.8635 24.9339C23.0231 25.0725 23.2269 25.1496 23.4383 25.1513H26.832C27.0434 25.1496 27.2472 25.0725 27.4068 24.9339C27.5664 24.7953 27.6712 24.6043 27.7025 24.3952L27.8871 23.094C28.7829 22.8571 29.6432 22.5023 30.4456 22.0389L31.4919 22.8214C31.6614 22.9486 31.871 23.0106 32.0825 22.996C32.2939 22.9815 32.4931 22.8915 32.6436 22.7423L35.0351 20.3508C35.1843 20.2003 35.2743 20.0011 35.2889 19.7897C35.3034 19.5782 35.2414 19.3686 35.1142 19.1991L34.3317 18.1528C34.795 17.3504 35.1498 16.49 35.3868 15.5943L36.688 15.4097C36.8965 15.3771 37.0867 15.2719 37.2251 15.1126C37.3634 14.9533 37.441 14.7502 37.4441 14.5392V11.1455C37.441 10.9345 37.3635 10.7314 37.2251 10.5721C37.0867 10.4128 36.8965 10.3076 36.688 10.275L35.3868 10.0904C35.1498 9.19461 34.795 8.33427 34.3317 7.53186L35.1142 6.4856C35.2414 6.31606 35.3034 6.10644 35.2889 5.89499C35.2743 5.68355 35.1843 5.48438 35.0351 5.33383L32.6436 2.94237C32.4931 2.7932 32.2939 2.70314 32.0825 2.68861C31.871 2.67408 31.6614 2.73606 31.4919 2.86324L30.4456 3.64574C29.6432 3.18243 28.7828 2.82765 27.8871 2.59068L27.7025 1.28945C27.6712 1.0804 27.5664 0.889369 27.4068 0.75075C27.2472 0.612132 27.0434 0.53503 26.832 0.533325H23.4383C23.2269 0.53503 23.0231 0.612132 22.8635 0.75075C22.7039 0.889369 22.5991 1.0804 22.5678 1.28945L22.3832 2.59068C21.4875 2.82765 20.6271 3.18243 19.8247 3.64574L18.7784 2.86324C18.6089 2.73606 18.3993 2.67408 18.1878 2.68861C17.9764 2.70314 17.7772 2.7932 17.6267 2.94237L15.2352 5.33383C15.086 5.48438 14.996 5.68355 14.9814 5.89499C14.9669 6.10644 15.0289 6.31606 15.1561 6.4856L15.9386 7.53186C15.4753 8.33427 15.1205 9.19461 14.8835 10.0904L13.5823 10.275C13.3738 10.3076 13.1836 10.4128 13.0452 10.5721C12.9068 10.7314 12.8293 10.9345 12.8262 11.1455V14.5392C12.8293 14.7502 12.9069 14.9533 13.0452 15.1126C13.1836 15.2719 13.3738 15.3771 13.5823 15.4097ZM25.1352 6.68787C26.3524 6.68787 27.5423 7.04882 28.5544 7.72509C29.5665 8.40135 30.3553 9.36255 30.8212 10.4871C31.287 11.6117 31.4089 12.8492 31.1714 14.043C30.9339 15.2369 30.3478 16.3335 29.487 17.1942C28.6263 18.055 27.5297 18.6411 26.3358 18.8786C25.142 19.1161 23.9045 18.9942 22.7799 18.5284C21.6553 18.0625 20.6941 17.2737 20.0179 16.2616C19.3416 15.2495 18.9807 14.0596 18.9807 12.8424C18.9825 11.2106 19.6315 9.64626 20.7853 8.49247C21.9391 7.33867 23.5034 6.68966 25.1352 6.68787Z"
                      fill="white"
                    />
                    <path
                      d="M25.1343 17.2385C27.5622 17.2385 29.5304 15.2704 29.5304 12.8425C29.5304 10.4146 27.5622 8.44641 25.1343 8.44641C22.7065 8.44641 20.7383 10.4146 20.7383 12.8425C20.7383 15.2704 22.7065 17.2385 25.1343 17.2385Z"
                      fill="white"
                    />
                  </svg>
                  <br />
                  <p className="text-white arr-p mb-0">
                    <Trans>Gamified Wellness Challenges:</Trans>
                  </p>
                  <p className="text-white mb-4 ">
                    <Trans>Engaging fitness competitions with real rewards.</Trans>
                  </p>
                </div>
                <div
                  className="col-3 p-3 svg-container "
                  style={{ borderTopRightRadius: '20px', borderBottomLeftRadius: '20px' }}
                >
                  <svg
                    className="mb-3"
                    xmlns="http://www.w3.org/2000/svg"
                    width="46"
                    height="43"
                    viewBox="0 0 46 43"
                    fill="none"
                  >
                    <path
                      d="M1.26642 27.7081H6.33117C7.03046 27.7081 7.59759 28.2659 7.59759 28.9543V41.4192C7.59759 42.1076 7.03046 42.6659 6.33117 42.6659H1.26642C0.567129 42.6659 0 42.1076 0 41.4192V28.9543C0 28.2659 0.567129 27.7081 1.26642 27.7081Z"
                      fill="#41D8B4"
                    />
                    <path
                      d="M13.9281 17.736H18.9933C19.6926 17.736 20.2597 18.2942 20.2597 18.9826V41.4192C20.2597 42.1076 19.6926 42.6658 18.9933 42.6658H13.9281C13.2288 42.6658 12.6621 42.1076 12.6621 41.4192V18.9826C12.6621 18.2942 13.2288 17.736 13.9281 17.736Z"
                      fill="white"
                    />
                    <path
                      d="M26.5906 22.722H31.6558C32.3551 22.722 32.9218 23.2803 32.9218 23.9687V41.4192C32.9218 42.1076 32.3551 42.6659 31.6558 42.6659H26.5906C25.8913 42.6659 25.3242 42.1076 25.3242 41.4192V23.9687C25.3242 23.2803 25.8913 22.722 26.5906 22.722Z"
                      fill="#41D8B4"
                    />
                    <path
                      d="M39.2547 15.2432H44.3194C45.0187 15.2432 45.5859 15.8014 45.5859 16.4898V41.4192C45.5859 42.1076 45.0187 42.6658 44.3194 42.6658H39.2547C38.5554 42.6658 37.9883 42.1076 37.9883 41.4192V16.4898C37.9883 15.8014 38.5554 15.2432 39.2547 15.2432Z"
                      fill="white"
                    />
                    <path
                      d="M41.7867 0.285431C39.6898 0.287713 37.9902 1.96069 37.9879 4.02487C37.993 4.43204 38.0663 4.83557 38.2049 5.219L31.8659 8.92831C31.034 8.05964 29.8278 7.63877 28.6259 7.79717C27.4235 7.95557 26.3727 8.67406 25.8018 9.7276L20.2108 7.00153C20.2381 6.84131 20.2544 6.67972 20.2604 6.51767C20.2632 5.004 19.339 3.63823 17.9191 3.05714C16.4992 2.47651 14.8636 2.79558 13.7762 3.86556C12.6883 4.93553 12.3632 6.54506 12.9526 7.94324L5.70004 13.2712C5.12503 12.9339 4.4684 12.754 3.79879 12.7504C1.70092 12.7504 0 14.4243 0 16.4898C0 18.5549 1.70092 20.2292 3.79879 20.2292C5.89666 20.2292 7.59759 18.5549 7.59759 16.4898C7.59434 16.0397 7.50809 15.5947 7.343 15.1752L14.6679 9.79379C16.1008 10.5803 17.888 10.3498 19.0663 9.22593L25.4244 12.3258C25.8482 14.1842 27.6247 15.4312 29.5478 15.2204C31.4708 15.0095 32.925 13.4086 32.9227 11.5037C32.9227 11.4088 32.9014 11.3193 32.8944 11.2262L39.789 7.19143C40.3867 7.56345 41.0791 7.76202 41.7867 7.7643C43.8846 7.7643 45.5855 6.08996 45.5855 4.02487C45.5855 1.95978 43.8846 0.285431 41.7867 0.285431Z"
                      fill="white"
                    />
                  </svg>
                  <br />
                  <p className="text-white arr-p mb-0">
                    <Trans>
                      Data-Driven <br /> Insights:
                    </Trans>
                  </p>
                  <p className="text-white mb-4 ">
                    <Trans>Track engagement & wellness ROI with deep analytics.</Trans>
                  </p>
                </div>
                <div
                  className="col-3 p-3 svg-container "
                  style={{ borderTopRightRadius: '20px', borderBottomLeftRadius: '20px' }}
                >
                  <svg
                    className="mb-3"
                    xmlns="http://www.w3.org/2000/svg"
                    width="47"
                    height="47"
                    viewBox="0 0 47 47"
                    fill="none"
                  >
                    <circle cx="32" cy="32" r="12" fill="#41D8B4" />
                    <path
                      d="M31.8535 16.707C23.5017 16.707 16.707 23.5017 16.707 31.8535C16.707 40.2053 23.5017 47 31.8535 47C40.2053 47 47 40.2053 47 31.8535C47 23.5017 40.2053 16.707 31.8535 16.707ZM31.8535 30.4766C34.1314 30.4766 35.9844 32.3296 35.9844 34.6074C35.9844 36.4002 34.8298 37.9143 33.2305 38.4846V41.4922H30.4766V38.4846C28.8773 37.9143 27.7227 36.4002 27.7227 34.6074H30.4766C30.4766 35.3671 31.0938 35.9844 31.8535 35.9844C32.6132 35.9844 33.2305 35.3671 33.2305 34.6074C33.2305 33.8477 32.6132 33.2305 31.8535 33.2305C29.5757 33.2305 27.7227 31.3775 27.7227 29.0996C27.7227 27.3068 28.8773 25.7927 30.4766 25.2224V22.2148H33.2305V25.2224C34.8298 25.7927 35.9844 27.3068 35.9844 29.0996H33.2305C33.2305 28.3399 32.6132 27.7227 31.8535 27.7227C31.0938 27.7227 30.4766 28.3399 30.4766 29.0996C30.4766 29.8593 31.0938 30.4766 31.8535 30.4766Z"
                      fill="white"
                    />
                    <path
                      d="M15.3301 16.707C23.8231 16.707 30.4766 13.0778 30.4766 8.44531C30.4766 3.81287 23.8231 0 15.3301 0C6.83703 0 0 3.81287 0 8.44531C0 13.0778 6.83703 16.707 15.3301 16.707Z"
                      fill="white"
                    />
                    <path
                      d="M0 30.9869V33.2305C0 37.8629 6.83703 41.4922 15.3301 41.4922C15.8118 41.4922 16.2786 41.4479 16.7529 41.4246C15.6967 39.7639 14.909 37.9212 14.4452 35.9513C8.30349 35.7817 2.97073 33.8945 0 30.9869Z"
                      fill="white"
                    />
                    <path
                      d="M14.0193 33.1604C13.9877 32.7273 13.9531 32.2946 13.9531 31.8535C13.9531 30.4181 14.1412 29.0288 14.462 27.6903C8.31267 27.5237 2.97339 25.6354 0 22.7252V24.9688C0 29.3555 6.17444 32.8029 14.0193 33.1604Z"
                      fill="white"
                    />
                    <path
                      d="M15.3301 24.9687C15.3315 24.9687 15.3327 24.9686 15.3343 24.9686C16.2424 22.7981 17.5626 20.8415 19.202 19.2022C17.9584 19.3594 16.6732 19.4609 15.3301 19.4609C8.79258 19.4609 3.1143 17.5114 0 14.4634V16.707C0 21.3395 6.83703 24.9687 15.3301 24.9687Z"
                      fill="white"
                    />
                  </svg>
                  <br />
                  <p className="text-white arr-p mb-0">
                    <Trans>Global Incentives & Compliance:</Trans>
                  </p>
                  <p className="text-white mb-4 ">
                    <Trans>Automated reward distribution with tax compliance.</Trans>
                  </p>
                </div>
                <div
                  className="col-3 p-3 svg-container "
                  style={{ borderTopRightRadius: '20px', borderBottomLeftRadius: '20px' }}
                >
                  <svg
                    className="mb-3"
                    xmlns="http://www.w3.org/2000/svg"
                    width="46"
                    height="46"
                    viewBox="0 0 46 46"
                    fill="none"
                  >
                    <path
                      d="M5.69819 25.6418C5.69819 23.2852 7.6152 21.3682 9.97183 21.3682C12.3285 21.3682 14.2455 23.2852 14.2455 25.6418H17.0946C17.0946 25.6418 17.0946 20.9974 17.0946 20.9843C17.0946 19.9199 18.321 19.2199 19.239 19.7545C20.1646 20.2934 21.3682 19.5912 21.3682 18.5191C21.3682 17.4845 20.1483 16.7487 19.2392 17.2837C18.3105 17.8301 17.0946 17.1265 17.0946 16.054V8.54727H4.27364C1.91701 8.54727 0 10.4643 0 12.8209V25.6418H5.69819Z"
                      fill="white"
                    />
                    <path
                      d="M17.0946 39.8873C14.7379 39.8873 12.8209 37.9703 12.8209 35.6137C12.8209 33.2571 14.7379 31.3401 17.0946 31.3401V28.491H12.4363C11.3736 28.491 10.6539 27.2915 11.2071 26.3459C11.7414 25.4327 11.0502 24.2174 9.97193 24.2173C8.94022 24.2172 8.2042 25.4392 8.73642 26.3457C9.28349 27.2774 8.5853 28.491 7.50739 28.491H0V41.3119C0 43.6685 1.91701 45.5855 4.27364 45.5855H17.0946V39.8873Z"
                      fill="white"
                    />
                    <path
                      d="M31.3399 28.4909C31.3399 30.8476 29.4229 32.7646 27.0663 32.7646C24.7097 32.7646 22.7927 30.8476 22.7927 28.4909H19.9436V33.1485C19.9436 34.2159 18.7198 34.9156 17.7991 34.3783C16.879 33.8414 15.67 34.5401 15.6699 35.6136C15.6699 36.6521 16.8881 37.3852 17.7991 36.849C18.7229 36.3053 19.9436 37.0168 19.9436 38.0788V45.5855H32.7645C35.1211 45.5855 37.0381 43.6685 37.0381 41.3119V28.4909H31.3399Z"
                      fill="white"
                    />
                    <path
                      d="M41.3126 0H27.0671C26.2797 0 25.6426 0.637157 25.6426 1.42455V7.50667C25.6426 8.58663 26.8568 9.27974 27.7877 8.73651C28.7198 8.19257 29.9162 8.91084 29.9162 9.97179C29.9163 11.0117 28.7002 11.746 27.7879 11.2073C26.8627 10.661 25.6426 11.375 25.6426 12.437V18.5191C25.6426 19.3065 26.2797 19.9437 27.0671 19.9437H31.3408C31.3408 22.3003 33.2578 24.2173 35.6144 24.2173C37.971 24.2173 39.8881 22.3003 39.8881 19.9437H44.1617C44.9491 19.9437 45.5862 19.3065 45.5862 18.5191V4.27364C45.5862 1.91701 43.6692 0 41.3126 0Z"
                      fill="#41D8B4"
                    />
                  </svg>
                  <br />
                  <p className="text-white arr-p mb-0">
                    <Trans>Seamless HR Tech Integrations:</Trans>
                  </p>
                  <p className="text-white  mb-4">
                    <Trans>Works with top HR & benefits platforms.</Trans>
                  </p>
                </div>
                <div
                  className="col-3 p-3 svg-container "
                  style={{ borderTopRightRadius: '20px', borderBottomLeftRadius: '20px' }}
                >
                  <svg
                    className="mb-3"
                    xmlns="http://www.w3.org/2000/svg"
                    width="46"
                    height="46"
                    viewBox="0 0 46 46"
                    fill="none"
                  >
                    <path
                      d="M15.1328 35.3086C16.6034 40.5699 19.0071 44.9148 21.6432 46V35.3086H15.1328Z"
                      fill="white"
                    />
                    <path
                      d="M13.5098 24.5273C13.5958 27.263 13.9373 30.0185 14.4845 32.6133H21.6439V24.5273H13.5098Z"
                      fill="white"
                    />
                    <path
                      d="M24.3477 35.3086V46C26.9838 44.9148 29.3964 40.5699 30.867 35.3086H24.3477Z"
                      fill="white"
                    />
                    <path
                      d="M10.8159 24.5273H0.0683594C0.236457 27.3959 0.92448 30.1218 2.05624 32.6133H11.723C11.2006 30.0275 10.8953 27.2891 10.8159 24.5273Z"
                      fill="white"
                    />
                    <path
                      d="M12.3661 35.3086H3.50977C6.5446 40.1455 11.3255 43.9809 16.9717 45.5004C15.0403 43.077 13.4521 39.348 12.3661 35.3086Z"
                      fill="white"
                    />
                    <path
                      d="M33.6349 35.3086C32.5488 39.348 30.9607 43.077 29.0293 45.5004C34.6754 43.9809 39.4564 40.1455 42.4912 35.3086H33.6349Z"
                      fill="white"
                    />
                    <path
                      d="M35.1844 24.5273C35.105 27.2891 34.7996 30.0275 34.2773 32.6133H43.9441C45.0758 30.1218 45.7639 27.3959 45.932 24.5273H35.1844Z"
                      fill="white"
                    />
                    <path
                      d="M24.3477 24.5273V32.6133H31.5161C32.0633 30.0185 32.4048 27.263 32.4908 24.5273H24.3477Z"
                      fill="white"
                    />
                    <path
                      d="M23 0C20.027 0 17.5195 2.68714 17.5195 5.66016C17.5195 8.63318 20.027 11.0508 23 11.0508C25.973 11.0508 28.4805 8.63318 28.4805 5.66016C28.4805 2.68714 25.973 0 23 0Z"
                      fill="white"
                    />
                    <path
                      d="M39.2617 5.66016C37.0323 5.66016 35.2188 7.47374 35.2188 9.70312C35.2188 11.9325 37.0323 13.7461 39.2617 13.7461C41.4911 13.7461 43.3047 11.9325 43.3047 9.70312C43.3047 7.47374 41.4911 5.66016 39.2617 5.66016Z"
                      fill="white"
                    />
                    <path
                      d="M6.73828 5.66016C4.5089 5.66016 2.69531 7.47374 2.69531 9.70312C2.69531 11.9325 4.5089 13.7461 6.73828 13.7461C8.96766 13.7461 10.7812 11.9325 10.7812 9.70312C10.7812 7.47374 8.96766 5.66016 6.73828 5.66016Z"
                      fill="white"
                    />
                    <path
                      d="M43.2247 15.1252C42.1095 15.943 40.7472 16.4414 39.2615 16.4414C37.7729 16.4414 36.4081 15.9404 35.2918 15.1197C34.6436 15.6033 34.0522 16.1571 33.6113 16.8379C33.7735 17.5803 33.8709 18.3463 33.8709 19.1367V21.832H45.0478C45.5736 21.832 45.9998 21.4058 45.9998 20.8801C45.9998 18.5965 44.9272 16.4564 43.2247 15.1252Z"
                      fill="white"
                    />
                    <path
                      d="M27.5307 12.4052C26.2545 13.2483 24.6408 13.7461 23 13.7461C21.3613 13.7461 19.7496 13.2491 18.4743 12.408C16.2356 13.9403 14.8242 16.6145 14.8242 19.4602V20.4844C14.8242 21.2392 15.4171 21.832 16.1719 21.832H29.8281C30.5829 21.832 31.1758 21.2392 31.1758 20.4844V19.1367C31.1758 16.2468 29.7193 13.8468 27.5307 12.4052Z"
                      fill="#41D8B4"
                    />
                    <path
                      d="M10.708 15.1197C9.59154 15.9404 8.2269 16.4414 6.73828 16.4414C5.25263 16.4414 3.89032 15.943 2.77509 15.1252C1.07255 16.4564 0 18.5965 0 20.8801V21.832H12.1289V19.1367C12.1289 18.3463 12.2263 17.5803 12.3885 16.8379C11.9476 16.1571 11.356 15.6034 10.708 15.1197Z"
                      fill="white"
                    />
                  </svg>
                  <br />
                  <p className="text-white arr-p mb-0">
                    <Trans>Expand Geographically:</Trans>
                  </p>
                  <p className="text-white  mb-4">
                    <Trans>Digital solution with global support infrastructure.</Trans>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="form-partner" className="pl-0 pr-0 partner-2">
          <div className="">
            <div className="feat_box shadow active_challenge">
              <div className="d-flex m-d-block p-0 justify-content-end align-items-start">
                <div className="col-12 col-md-6 p-2 p-md-5" style={{ maxWidth: '700px' }}>
                  <h2 className=" pt-0 text-white text-center text-md-left w-100">
                    <Trans>
                      Schedule a<br />
                      Vantage Fit Demo
                    </Trans>
                  </h2>
                  <p className="text-white my-4 text-white">
                    <Trans>
                      Explore a new era of team health with our corporate wellness platform,tailored to enhance employee
                      well-being!
                    </Trans>
                  </p>
                  <div className="partner-form " style={{ marginTop: '2.5rem !important' }}>
                    <Lazyload offset={10}>
                      <HubspotBrochureDownload formID={t(`aa0db87c-6ed2-43ba-a09b-f7fc33acc022`)} />
                    </Lazyload>
                  </div>
                </div>
                <div className="col-12 col-md-6 bg-white">
                  <div className="w-100 p-2 p-md-5 h-100" style={{ maxWidth: '690px' }}>
                    <h2 className="text-black text-center text-md-left pt-0 w-100 mb-5">
                      <Trans>
                        Choose a Partnership
                        <br />
                        Model That Works for You
                      </Trans>{' '}
                    </h2>
                    <div
                      className="rounded-lg bg-white p-4 demo-dialouge"
                      style={{ boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}
                    >
                      <div className="row">
                        <div className="col-9 px-0">
                          {' '}
                          <h3 className="m-0 p-0">
                            <Trans>Referral Partnership</Trans>
                          </h3>{' '}
                          <span>
                            <Trans>(For HR Consultants, SaaS Vendors, & Advisors)</Trans>
                          </span>
                        </div>
                        <div className="col-3 p-0 d-flex justify-content-end">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="85"
                            height="83"
                            viewBox="0 0 85 83"
                            fill="none"
                          >
                            <path d="M0 0H61C74.2548 0 85 10.7452 85 24V83H0V0Z" fill="#41D8B4" />
                            <path
                              d="M54.0235 45.0023C53.9175 45.0023 53.8235 45.0303 53.7135 45.0343L47.6584 34.6797C48.7841 33.5638 49.5529 32.1387 49.8672 30.5852C50.1815 29.0316 50.0272 27.4197 49.4239 25.9541C48.8205 24.4884 47.7953 23.235 46.4784 22.3529C45.1615 21.4709 43.6122 21 42.0272 21C40.4422 21 38.8929 21.4709 37.5759 22.3529C36.259 23.235 35.2338 24.4884 34.6305 25.9541C34.0271 27.4197 33.8728 29.0316 34.1872 30.5852C34.5015 32.1387 35.2703 33.5638 36.396 34.6797L30.3588 45.0363C30.2448 45.0303 30.1408 45.0023 30.0268 45.0023C28.5296 44.997 27.061 45.4121 25.788 46.2003C24.515 46.9886 23.4888 48.1182 22.8261 49.4608C22.1634 50.8034 21.8909 52.3051 22.0395 53.795C22.1881 55.2848 22.7519 56.703 23.6667 57.8883C24.5815 59.0736 25.8106 59.9783 27.2141 60.4996C28.6177 61.0209 30.1394 61.1377 31.6061 60.8369C33.0728 60.536 34.4257 59.8295 35.5107 58.7978C36.5958 57.7661 37.3694 56.4506 37.7438 55.0009H46.3066C46.6828 56.4464 47.4569 57.7575 48.5408 58.7852C49.6248 59.8128 50.9752 60.516 52.4387 60.8147C53.9022 61.1134 55.4202 60.9957 56.8202 60.475C58.2202 59.9544 59.4461 59.0515 60.3587 57.869C61.2713 56.6866 61.8341 55.2719 61.983 53.7856C62.132 52.2994 61.8612 50.8012 61.2014 49.4611C60.5416 48.1211 59.5192 46.9929 58.2504 46.2047C56.9816 45.4165 55.5172 44.9999 54.0235 45.0023ZM46.3066 51.0014H37.7438C37.2359 49.0352 35.9982 47.3362 34.2823 46.2501L39.8675 36.6714C41.2737 37.1154 42.7826 37.1154 44.1889 36.6714L49.7881 46.2421C48.0623 47.3256 46.8166 49.0285 46.3066 51.0014Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <ul className="pricing-one-time-bullets pricing-standard-bullets mt-0 pl-4">
                          <li className="text-black pl-4 mt-0">
                            <p className="mb-1 ">
                              <b>
                                <Trans>$0 upfront investment</Trans>
                              </b>
                            </p>
                            <p className="font-weight-normal no-br mb-4">
                              <Trans>No risk, just commissions</Trans>{' '}
                            </p>
                          </li>
                          <li className="text-black pl-4">
                            <p className="mb-1 ">
                              <b>
                                <Trans>Get Paid for Every Sale</Trans>
                              </b>{' '}
                            </p>
                            <p className="font-weight-normal no-br mb-4">
                              <Trans>Earn commissions on each successful referral</Trans>{' '}
                            </p>
                          </li>
                          <li className="text-black pl-4 mb-0">
                            <p className="mb-0 ">
                              <b>
                                <Trans>We Handle Everything</Trans>
                              </b>{' '}
                            </p>
                            <p className="font-weight-normal no-br mb-0">
                              <Trans>You introduce, we close the deal, you earn</Trans>{' '}
                            </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div
                      className="rounded-lg bg-white p-4 mt-5 demo-dialouge"
                      style={{ boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}
                    >
                      <div className="row">
                        <div className="col-9 px-0">
                          {' '}
                          <h3 className="m-0 p-0">
                            <Trans>Reseller Partnership</Trans>
                          </h3>{' '}
                          <span>
                            <Trans>(For Agencies, HR Tech Providers, & Wellness Providers)</Trans>{' '}
                          </span>
                        </div>
                        <div className="col-3 p-0 d-flex justify-content-end">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="85"
                            height="83"
                            viewBox="0 0 85 83"
                            fill="none"
                          >
                            <path d="M0 0H61C74.2548 0 85 10.7452 85 24V83H0V0Z" fill="#41D8B4" />
                            <path
                              d="M40.375 63.126C40.375 63.4201 40.0727 63.6168 39.803 63.4981L23.5091 56.3173C22.8981 56.067 22.5 55.4723 22.5 54.8125V38.5625C22.5 37.9093 22.9599 37.2771 23.5091 37.0578L34.8825 32.4054C35.7096 32.0706 36.6635 32.4606 37.0031 33.2943C37.3428 34.1246 36.9446 35.0736 36.1143 35.4133L28.4166 38.5625L40.375 44.25V63.126Z"
                              fill="white"
                            />
                            <path
                              d="M61.5 38.5625V54.8125C61.5 55.4723 61.1019 56.067 60.4909 56.3173L44.197 63.4981C43.9272 63.6168 43.625 63.4201 43.625 63.126V44.25L55.5834 38.5625L47.8906 35.4149C47.0603 35.0753 46.6621 34.1263 47.0017 33.2959C47.3414 32.4639 48.2969 32.0723 49.1224 32.4087L60.4909 37.0594C61.0564 37.2902 61.5 37.919 61.5 38.5625Z"
                              fill="white"
                            />
                            <path
                              d="M50.0018 26.9974C49.7516 27.6035 49.1568 28 48.5003 28H45.2503V34.5H38.7503V28H35.5003C34.8438 28 34.2491 27.6035 33.9988 26.9974C33.7469 26.3896 33.8867 25.6909 34.3514 25.2261L40.8514 18.7261C41.1683 18.4092 41.5843 18.25 42.0003 18.25C42.4163 18.25 42.8323 18.4092 43.1492 18.7261L49.6492 25.2261C50.1139 25.6909 50.2537 26.3896 50.0018 26.9974Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <ul className="pricing-one-time-bullets pricing-standard-bullets mt-0 pl-4">
                          <li className="text-black pl-4 mt-0">
                            <p className="font-weight-semibold mb-1 font-weight-medium">
                              <b>
                                <Trans>Own the Revenue</Trans>
                              </b>{' '}
                            </p>
                            <p className=" no-br mb-4">
                              <Trans>Sell under your brand, at your pricing</Trans>{' '}
                            </p>
                          </li>
                          <li className="text-black pl-4">
                            <p className="font-weight-semibold mb-1 font-weight-medium">
                              <b>
                                <Trans>Higher Margins</Trans>
                              </b>{' '}
                            </p>
                            <p className=" no-br mb-4">
                              <Trans>More control, bigger commissions</Trans>{' '}
                            </p>
                          </li>
                          <li className="text-black pl-4">
                            <p className="font-weight-semibold mb-0 font-weight-medium">
                              <b>
                                <Trans>Co-branding</Trans>
                              </b>{' '}
                            </p>
                            <p className=" no-br mb-4">
                              <Trans>Offer Vantage Fit as a co-branded solution</Trans>{' '}
                            </p>
                          </li>
                          <li className="text-black pl-4 mb-0">
                            <p className="font-weight-semibold mb-0 font-weight-medium">
                              <b>
                                <Trans>Scalable Growth</Trans>
                              </b>{' '}
                            </p>
                            <p className=" no-br mb-0">
                              <Trans>Start with 100+ licenses and expand as you grow</Trans>{' '}
                            </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section style={{ background: '#1D2228' }}>
          <div className="position-relative">
            <div className="">
              <div className="sect-white-col-2 active_challenge">
                <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-start">
                  <div className="col-12">
                    <img
                      className="img-responsive"
                      src="https://res.cloudinary.com/vantagecircle/image/upload/v1742973814/VantageFit/2025/badges.png"
                      alt="badges"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section-pdn about-pattern-vfit apv position-relative">
          <div className="container custom_container px-6">
            <div className="testi-video-wrapper">
              <div className="row col-12 d-flex justify-content-between align-items-center p0">
                <div className="col-12 col-md-4 h-full p0">
                  <h2 className="py-2 section-heading no-br">
                    <Trans>
                      Real people, <br />
                      Real results
                    </Trans>
                  </h2>
                  <p className="section-para">
                    <Trans>Vantage Fit speaks for itself, but our customer reviews speak even louder.</Trans>
                  </p>
                </div>
                <div className="col-12 col-md-8 px-0">
                  <div className="">
                    <Lazyload offset={300}>
                      <VideoCarousel videoUrls={wistiaVideoUrls} />
                    </Lazyload>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
          <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
            <div className="col-12">
              <h1 className="font-weight-semibold section-heading text-center no-br">
                <Trans>
                  Boost your revenue as a<br />
                  Vantage Fit partner
                </Trans>
              </h1>
              <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                <a href="#form-partner" className="vfitcompanycta arrowbtn-img">
                  <Trans>Join the program</Trans>
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default Partnership
